import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { RiEditBoxFill } from 'react-icons/ri';

import Modal from 'common-components/Modal';
import ImageModal from './components/ImageModal';
import ReviseUrlCategory from './components/ReviseUrlCategory';
import ReviewMenu from './components/ReviewMenu';
import Alert from 'common-components/Alert';
import UrlDataTabs from './components/UrlDataTabs';
import { getAnaliserResult, getS3Data } from './api';
import {
  SERVER_ERROR,
  LOGIN_ERROR
} from 'common-components/Alert/alertMessage.config';
import useKeyboardShortcut from 'lib/keyboard-shortcut';

import './urlReviewModal.style.css';


const UrlReviewModal = ({
  show,
  rowData,
  onSave,
  onIgnore,
  onSaveAndNext,
  onIgnoreAndNext,
  onClose,
  authHeader,
  dropDownCat,
  revisedCat,
  setRevisedCat,
  saveSpinner,
  saveAndNextSpinner,
  ignoreSpinner,
  ignoreAndNextSpinner,
}) => {
  const [alertData, setAlertData] = useState({});
  const [updatedRowData, setUpdatedData] = useState(null);
  const [analyserResult, setAnalyserResult] = useState(null);
  const [metaData, setMetaData] = useState(null);
  const [pageSource, setPageSource] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);

  const openImageKey = ['Z'];
  const closeImageKey = ['X'];

  const handleOpenImageKeyboardShortcut = useCallback(keys => {
    setShowImageModal(true);
  }, [setShowImageModal]);

  const handleCloseImageFilterShortcut = useCallback(keys => {
    setShowImageModal(false);
  }, [setShowImageModal]);

  useKeyboardShortcut(openImageKey, handleOpenImageKeyboardShortcut);
  useKeyboardShortcut(closeImageKey, handleCloseImageFilterShortcut);

  const loadAnaliserResult = async (urlId) => {
    setIsLoading(true);

    let data;
    let response = await getAnaliserResult(authHeader, urlId);

    if (response && response.status == 401) setAlertData(LOGIN_ERROR);
    else if (response && response.status.toString().match(/2\d{2}/)) data = response.data;
    else setAlertData(SERVER_ERROR);

    setAnalyserResult(data);
    setIsLoading(false);
  };

  const loadMetaData = async (s3Link) => {
    let response = await getS3Data(s3Link);
    if (response) setMetaData(response);
  };

  const loadPageSource = async (s3Link) => {
    let response = await getS3Data(s3Link);
    if (response) setPageSource(response);
  };

  useEffect(() => {
    if (rowData) {
      setUpdatedData({ ...rowData });
      loadAnaliserResult(rowData.url_metadata_id);
      loadMetaData(rowData.meta_data_s3_location);
      loadPageSource(rowData.page_source_s3_location);
    };
  }, [rowData?.id]);

  const modalContent = () => {
    return (
      <>
        <div className='modal-header'>
          <span >
            <RiEditBoxFill className='url-icon' />
          </span>
          <span>
            {updatedRowData && updatedRowData.normalized_url}
          </span>
        </div>
        <div className='review-modal-content'>
          <ReviseUrlCategory
            urlCatList={updatedRowData && updatedRowData.all_categories}
            allCatList={dropDownCat}
            revisedCat={revisedCat}
            setRevisedCat={setRevisedCat}
            rowData={rowData}
          />
          <UrlDataTabs
            screenshotLink={updatedRowData && updatedRowData.image_s3_location}
            metaData={metaData}
            pageSource={pageSource}
            analyserResult={analyserResult}
            isLoading={isLoading}
            setShowImageModal={setShowImageModal}
          />
          <ReviewMenu
            onSave={onSave}
            onIgnore={onIgnore}
            onSaveAndNext={onSaveAndNext}
            onIgnoreAndNext={onIgnoreAndNext}
            onClose={onClose}
            data={updatedRowData}
            isLoading={isLoading}
            hasMultiCat={updatedRowData && updatedRowData.all_categories.length > 1}
            saveSpinner={saveSpinner}
            saveAndNextSpinner={saveAndNextSpinner}
            ignoreSpinner={ignoreSpinner}
            ignoreAndNextSpinner={ignoreAndNextSpinner}
          />
          {showImageModal && (
            <ImageModal
              screenshotLink={updatedRowData && updatedRowData.image_s3_location}
              setShowImageModal={setShowImageModal}
              showImageModal={showImageModal}
            />
          )}
        </div >
      </>
    )
  };

  return (
    <div className='review-modal-container'>
      <Modal
        showModal={show}
        setShowModal={onClose}
        content={modalContent()}
      />
      <Alert
        showModal={alertData.showModal}
        setShowModal={setAlertData}
        data={alertData}
      />
    </div >
  )
};

const mapStateToProps = ({
  authentication: { priviledge, authHeader },
  categories: { existingCategories } }) => ({
    priviledge,
    authHeader,
    existingCategories
  });

export default connect(mapStateToProps)(UrlReviewModal);